module.exports = __webpack_public_path__ + "img/proflightS2.f4d5610d.png";